// Route for a piece of publishable content, from the {kind, id} refs the
// backend stamps into Task.meta (publish tasks) and ScreenLog.meta
// (content_applied events). Media/audio have no per-item page → their library.
// Shared by the Activity feed's task rows and the screen activity log so the
// two surfaces always link the same way.
export function contentRoute(kind: unknown, id: unknown): string | null {
  if (typeof kind !== 'string' || typeof id !== 'number') return null
  switch (kind) {
    case 'playlist':       return `/management/media/playlists/${id}`
    case 'layout':         return `/management/layouts/${id}`
    // 'menu' is an Interactive Link (the visual menu was dropped) — links
    // have no per-item page, so open the Links tab.
    case 'menu':           return '/management/media#links'
    case 'media':          return '/management/media'
    case 'audio':          return '/audio-hub'
    case 'audio_playlist': return `/audio-hub/playlists/${id}`
    default:               return null
  }
}
